import ShareTooltip from './ShareTooltip'

export default ShareTooltip
// eslint-disable-next-line import/export
export * from './ShareTooltip'
